import component from './index.vue'

const Plugin = {
  install (Vue, options = {}) {
    if (this.installed) {
      return
    }
    this.installed = true
    this.event = new Vue()

    Vue.component('searchDatePicker', component)
    // Vue.mixin({
    // })

    Vue.prototype.$searchDatePicker = {
      // focus () {
      //   Plugin.event.$emit('focus')
      // }
    }
  }
}

// This exports the plugin object.
export default Plugin
